export var AUTH_METHOD = /* @__PURE__ */ ((AUTH_METHOD2) => {
  AUTH_METHOD2["PASSWORD"] = "password";
  AUTH_METHOD2["CODE"] = "code";
  return AUTH_METHOD2;
})(AUTH_METHOD || {});
export var AUTH_STATE = /* @__PURE__ */ ((AUTH_STATE2) => {
  AUTH_STATE2["ANONYMOUS"] = "anonymous";
  AUTH_STATE2["IDENTIFIED"] = "identified";
  AUTH_STATE2["LOGGEDIN"] = "loggedin";
  AUTH_STATE2["ADMIN"] = "admin";
  AUTH_STATE2["SYSTEM"] = "system";
  return AUTH_STATE2;
})(AUTH_STATE || {});
export const AUTH_LEVEL = [
  "anonymous" /* ANONYMOUS */,
  "identified" /* IDENTIFIED */,
  "loggedin" /* LOGGEDIN */,
  "admin" /* ADMIN */
];
export var SCOPE = /* @__PURE__ */ ((SCOPE2) => {
  SCOPE2["EMAIL_API"] = "email_api";
  SCOPE2["CHECKOUT_FINALIZE"] = "checkout_finalize";
  SCOPE2["CONTACT_CARD_READ"] = "contact_card_read";
  SCOPE2["DELEGATED_API_CALL"] = "delegated_api_call";
  return SCOPE2;
})(SCOPE || {});
